(() => {
  const init = () => {
    document.querySelectorAll('[data-ass-page]').forEach((page) => {
      const filterButtons = [...page.querySelectorAll('[data-ass-filter]')];
      const serviceCards = [...page.querySelectorAll('[data-ass-stage]')];

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.assFilter;
          filterButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          serviceCards.forEach((card) => {
            card.hidden = filter !== 'all' && card.dataset.assStage !== filter;
          });
        });
      });

      const resourceButtons = [...page.querySelectorAll('[data-resource-filter]')];
      const resourceCards = [...page.querySelectorAll('[data-resource-card]')];
      const resourceSearch = page.querySelector('[data-resource-search]');
      let activeCategory = 'all';

      const updateResources = () => {
        const query = (resourceSearch?.value || '').trim().toLocaleLowerCase();
        resourceCards.forEach((card) => {
          const categoryMatch = activeCategory === 'all' || card.dataset.resourceCategory === activeCategory;
          const textMatch = !query || card.textContent.toLocaleLowerCase().includes(query);
          card.hidden = !(categoryMatch && textMatch);
        });
      };

      resourceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.resourceFilter;
          resourceButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          updateResources();
        });
      });
      resourceSearch?.addEventListener('input', updateResources);

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        page.querySelectorAll('.ass-reveal').forEach((item) => observer.observe(item));
      } else {
        page.querySelectorAll('.ass-reveal').forEach((item) => item.classList.add('is-visible'));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
